import { Badge, Col, Row } from "react-bootstrap";
import { Button, Form, Modal, Select, Space, Switch, Tag, Tooltip, notification, Tabs, Checkbox } from "antd";
import { CallServices, CoreServices } from "../../../../base/service/apiServices";
import React, { lazy, useCallback, useEffect, useState } from "react";
import { ChatActions } from "../../../../store/slices/chat_slice/chat_slice";
import { WtButton } from "../../../../shared/widges/Button/button";
import moment from "moment";
import styles from "./chatLeftSideBar.module.scss";
import { useDispatcher } from "../../../../custom_hooks/use_app_dispatch";
import { useSelector } from "react-redux";
import { LocalStorage } from "../../../../custom_hooks/localStorageKeys";
import { GetItemFromStorage, SetItemInStorage } from "../../../../custom_hooks/useStorage";
import { PRIVILLEGED_ROLES, ROLES } from "../../../../base/constant";
import { AntTextAreas } from "../../../../shared/widges/anttextArea";
import Success from '../../../../../src/styles/images/Success.svg';
import { CheckBoxFields } from "../../../../shared/widges/checkbox";
import Recapture from '../../../../../src/styles/images/recaptureimg.svg';
import { divide } from "lodash";
import facedenied from '../../../../../src/styles/images/facedenied.svg';
import CreateForm from '../../../contact/addcontact/create_form'
const MergeContact = lazy(() => import('../../../contact/popUpModels/models').then(module => ({ default: module.MergeContact })));


type leftsidebarProps = {
  apiData: any;
};

const { Option } = Select;

function LeftSidebarProfile() {
  const datacol=[]
  const campaign: any = useSelector((state: any) => state.outboundcampaign)
   const [tableData, setTableData] = useState([]);
  const { TabPane } = Tabs;
  const roleId = GetItemFromStorage(LocalStorage.ROLE_ID);
  const LoginUserDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS)
  const isContactEditOpendata = GetItemFromStorage("isUpdate");
  // let chatReducer: any = store.getState().chatReducer;
  const chatReducer: any = useSelector((state: any) => state.chatReducer);
  const { currentSession, sessionList, coidcontact } = chatReducer;
  const [customerData, setCustomerData] = useState<any>(null);

  const [counter, setCounter] = useState(0);
  const contactList: any = useSelector((state: any) => state.contactListForAgent);
  const dispatch = useDispatcher();

  const { allCustomerTagList } = contactList;

  const [enableChat, setEnableChat] = useState<any>(false);
  const [form] = Form.useForm();
  const [isModalVisible7, setIsModalVisible7] = useState(false);
  const [isModalVisible5, setIsModalVisible5] = useState(false);

  const [dndDescriptionValue, setDndDescriptionValue] = useState('');
  const [blockDescriptionValue, setBlockDescriptionValue] = useState('');
  const [doNotDisturbModal, setDoNotDisturbModal] = useState<any>(false)
  const [doNotDisturbReqModal, setDoNotDisturbReqModal] = useState<any>(false)
  const [customerBlockModal, setCustomerBlockModal] = useState<any>(false)
  const [customerBlockReqModal, setCustomerBlockReqModal] = useState<any>(false)
  const [analysing, setAnalysing] = useState(false);

  const data = [
    { id: 1, name: 'Aadhar card', email: 'Jane Cooper Fernandez' },
    { id: 2, name: 'Bob', email: 'bob@example.com' },
    { id: 3, name: 'Charlie', email: 'charlie@example.com' }
  ];
  const editTagEnable = (e: any) => {
    try {
      setEnableChat(!enableChat);
      if (e === "save") {
        const tags = {
          tags: JSON.parse(currentSession?.calledPersonDetails.tags),
        };
        CoreServices.put(tags, `/update_customer_contct_tag/${currentSession?.calledPersonDetails?.coid}`).then((response: any) => {
          if (response.data.statusCode === 200) {
            notification.info({
              message: `Tag updated successfully`,
              placement: "topRight",
              className: "toastNotification success",
              icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM15.2197 8.96967L10.75 13.4393L8.78033 11.4697C8.48744 11.1768 8.01256 11.1768 7.71967 11.4697C7.42678 11.7626 7.42678 12.2374 7.71967 12.5303L10.2197 15.0303C10.5126 15.3232 10.9874 15.3232 11.2803 15.0303L16.2803 10.0303C16.5732 9.73744 16.5732 9.26256 16.2803 8.96967C15.9874 8.67678 15.5126 8.67678 15.2197 8.96967Z" fill="#000" />
              </svg>,
              closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
              </svg>,
              duration: 3,
              top: 70,
            });
          } else {
            notification.info({
              message: `Somting went wrong`,
              placement: "topRight",
              className: "toastNotification error",
              icon: <span className="icon__Error24" />,
              closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
              </svg>,
              duration: 3,
              top: 70,
            });
          }
        });
      }
    } catch (error) {
      console.log(error)
    }
  };

  const [openUpdateForm, setOpenUpdateForm] = useState({
    open : false,
    coid : 0
  })

  const [openMergeForm, setOpenMergeForm] = useState({
    open : false,
    coid : 0
  })
  const updateProfileFunc = () => {
    dispatch(ChatActions.isContactEditOpenset({ isUpdate: true, sessionUpdateProfile: currentSession.sessionId, coidcontact: currentSession.calledPersonDetails?.coid }));
    SetItemInStorage("isUpdate", "1");
    SetItemInStorage("contactSession", currentSession.sessionId);
    let coid = currentSession?.calledPersonDetails?.coid
    if (currentSession?.channelType === 'Chat' || currentSession?.ChatHistoryId)
      coid = currentSession?.CustomerId
    // window.open(`${window.location.origin}/supervisorprofilecontact/display?id=${coid}`, "_blank");
    // window.open(`${window.location.origin}/contactsdetail?coid=${coid}`, "_blank");s
    if(coid){
      setOpenUpdateForm({ open : true, coid: coid})
    }
  };


  useEffect(() => {
    setCustomerData(null);
    if (currentSession.channelType === 'Email') {
      let email: any = currentSession?.FromEmail.split('@')
      let temp: any = { email: currentSession?.FromEmail, name: '' }
      setCustomerData(temp);
    }
  }, [currentSession])

  const blockCustomerFun = async () => {
    if (blockDescriptionValue === '' && currentSession?.calledPersonDetails?.blockCustomerReq === 0 && currentSession?.calledPersonDetails?.blockCustomer == 0)
      return

    if (roleId == ROLES.AGENT_ROLE_ID) {
      if (currentSession?.calledPersonDetails?.blockCustomer === 1)
        return
      const isRemoveUpdate = currentSession?.calledPersonDetails?.blockCustomerReq === 0 ? true : false
      await CoreServices.put(
        { blockCustomerReq: currentSession?.calledPersonDetails?.blockCustomerReq === 0 ? 1 : 0, blockedReqBy: LoginUserDetails?.UserID, reason: blockDescriptionValue },
        `/update_block_customer_request/${currentSession.calledPersonDetails.coid}`
      ).then((response: any) => {
        if (response.data.statusCode === 200) {
          setCustomerBlockReqModal(false)
          dispatch(ChatActions.setBlockDataReqforContact());

          let msg = 'Block contact request has been sent to the supervisor'
          if (!isRemoveUpdate) {
            msg = "Removed From Block request List Successfully"
          }
          notification.info({
            message: msg,
            placement: "topRight",
            className: "toastNotification success",
            icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM15.2197 8.96967L10.75 13.4393L8.78033 11.4697C8.48744 11.1768 8.01256 11.1768 7.71967 11.4697C7.42678 11.7626 7.42678 12.2374 7.71967 12.5303L10.2197 15.0303C10.5126 15.3232 10.9874 15.3232 11.2803 15.0303L16.2803 10.0303C16.5732 9.73744 16.5732 9.26256 16.2803 8.96967C15.9874 8.67678 15.5126 8.67678 15.2197 8.96967Z" fill="#000" />
            </svg>,
            closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
              <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
            </svg>,
            duration: 3,
            top: 70,
          });
        }
      });
    } else {
      const blockedCustomer = {
        blockCustomer: currentSession?.calledPersonDetails?.blockCustomer == 0 ? 1 : 0,
        blockedBy: LoginUserDetails?.UserID,
        reason: blockDescriptionValue
      };
      const isRemoveUpdate = currentSession?.calledPersonDetails?.blockCustomer === 0 ? true : false
      CoreServices.put(blockedCustomer, `/update_block_customer/${currentSession?.calledPersonDetails?.coid}`).then((response: any) => {
        if (response.data.statusCode === 200) {
          setCustomerBlockModal(false);
          dispatch(ChatActions.setBlockDataforContact());
          let msg = 'Added to Block List Successfully'
          if (!isRemoveUpdate) {
            msg = "Removed From Block  List Successfully"
          }
          notification.info({
            message: msg,
            placement: "topRight",
            className: "toastNotification success",
            icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM15.2197 8.96967L10.75 13.4393L8.78033 11.4697C8.48744 11.1768 8.01256 11.1768 7.71967 11.4697C7.42678 11.7626 7.42678 12.2374 7.71967 12.5303L10.2197 15.0303C10.5126 15.3232 10.9874 15.3232 11.2803 15.0303L16.2803 10.0303C16.5732 9.73744 16.5732 9.26256 16.2803 8.96967C15.9874 8.67678 15.5126 8.67678 15.2197 8.96967Z" fill="#000" />
            </svg>,
            closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
              <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
            </svg>,
            duration: 3,
            top: 70,
          })
        }
      });
    }
  };


  const doNotDisturbFun = () => {
    if (dndDescriptionValue === '' && currentSession?.calledPersonDetails?.doNotDisturbReq === 0 && currentSession?.calledPersonDetails?.doNotDisturb === 0)
      return

    if (roleId == ROLES.AGENT_ROLE_ID) {
      if (currentSession?.calledPersonDetails?.doNotDisturb === 1)
        return
      const isRemoveUpdate = currentSession?.calledPersonDetails?.doNotDisturbReq === 0 ? true : false
      CoreServices.put(
        {
          doNotDisturbReq: currentSession?.calledPersonDetails?.doNotDisturbReq === 0 ? 1 : 0,
          doNotDisturbReqBy: LoginUserDetails?.UserID,
          reason: dndDescriptionValue
        },
        `/update_donotdisturb_customer_request/${currentSession?.calledPersonDetails?.coid}`
      ).then((response: any) => {
        if (response.data.statusCode === 200) {
          setDoNotDisturbReqModal(false);
          dispatch(ChatActions.setDNDDataReqforContact());
          let msg = 'DND contact request has been sent to the supervisor'
          if (!isRemoveUpdate) {
            msg = "Removed DND contact request "
          }
          notification.info({
            message: msg,
            placement: "topRight",
            className: "toastNotification success",
            icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM15.2197 8.96967L10.75 13.4393L8.78033 11.4697C8.48744 11.1768 8.01256 11.1768 7.71967 11.4697C7.42678 11.7626 7.42678 12.2374 7.71967 12.5303L10.2197 15.0303C10.5126 15.3232 10.9874 15.3232 11.2803 15.0303L16.2803 10.0303C16.5732 9.73744 16.5732 9.26256 16.2803 8.96967C15.9874 8.67678 15.5126 8.67678 15.2197 8.96967Z" fill="#000" />
            </svg>,
            closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
              <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
            </svg>,
            duration: 3,
            top: 70,
          });
        }
      });
    } else {
      const isRemoveUpdate = currentSession?.calledPersonDetails?.doNotDisturb === 0 ? true : false
      CoreServices.put(
        {
          doNotDisturb: currentSession?.calledPersonDetails?.doNotDisturb === 0 ? 1 : 0,
          doNotDisturbBy: LoginUserDetails?.UserID,
          reason: dndDescriptionValue
        }
        , `/update_donotdisturb_customer/${currentSession?.calledPersonDetails?.coid}`).then((response: any) => {
          if (response.data.statusCode === 200) {

            setDoNotDisturbModal(false);
            dispatch(ChatActions.setDNDDataforContact());
            let msg = 'Added to DND contact'
            if (!isRemoveUpdate) {
              msg = "Removed DND contact  "
            }
            notification.info({
              message: msg,
              placement: "topRight",
              className: "toastNotification success",
              icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM15.2197 8.96967L10.75 13.4393L8.78033 11.4697C8.48744 11.1768 8.01256 11.1768 7.71967 11.4697C7.42678 11.7626 7.42678 12.2374 7.71967 12.5303L10.2197 15.0303C10.5126 15.3232 10.9874 15.3232 11.2803 15.0303L16.2803 10.0303C16.5732 9.73744 16.5732 9.26256 16.2803 8.96967C15.9874 8.67678 15.5126 8.67678 15.2197 8.96967Z" fill="#000" />
              </svg>,
              closeIcon: <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                <path d="M5.80082 4.99937L9.70415 1.09571C9.92548 0.874973 9.92548 0.51564 9.70415 0.294906C9.48282 0.0735729 9.12342 0.0735729 8.90335 0.294906L5.00002 4.19851L1.09668 0.294906C0.876616 0.0735729 0.515949 0.0735729 0.295883 0.294906C0.0745495 0.51564 0.0745495 0.874973 0.295883 1.09571L4.19922 4.99937L0.295883 8.90304C0.0745495 9.12377 0.0745495 9.48311 0.295883 9.70384C0.406549 9.81451 0.551083 9.86984 0.696283 9.86984C0.841483 9.86984 0.986616 9.81451 1.09668 9.70384L5.00002 5.80024L8.90335 9.70384C9.01335 9.81451 9.15855 9.86984 9.30375 9.86984C9.44895 9.86984 9.59348 9.81451 9.70415 9.70384C9.92548 9.48311 9.92548 9.12377 9.70415 8.90304L5.80082 4.99937Z" fill="#757676" />
              </svg>,
              duration: 3,
              top: 70,
            });
          }
        })
    };
  }

  const onCloseContactForm = useCallback(()=>{
    setOpenUpdateForm({open: false, coid: 0})
    setOpenMergeForm({open: false, coid: 0})
  },[])

  const onMergeModel = useCallback(()=>{
    const coid = openUpdateForm?.coid;
    setOpenUpdateForm({open: false, coid: 0})
    setOpenMergeForm({open: true, coid: coid})
  },[openUpdateForm.coid])

  return (
    <>
      <>
        <div className={`scroller ${styles.userInfoSec}`}>
          <>
            <div className={styles.userInfo}>
              <div className={styles.usericon}>
                <h2>{(currentSession?.calledPersonDetails !== null && currentSession?.calledPersonDetails?.firstName !== undefined && currentSession?.calledPersonDetails?.firstName !== "" && currentSession?.calledPersonDetails?.firstName !== null) ? currentSession?.calledPersonDetails?.firstName?.charAt(0) : "N"}</h2>
              </div>
              <div className={`${styles.username} cname twolinetrukardtext`}>
                {currentSession?.calledPersonDetails?.firstName ?
                  (currentSession?.calledPersonDetails?.lastName ? (currentSession?.calledPersonDetails?.firstName + " " + currentSession?.calledPersonDetails?.lastName)
                    : currentSession?.calledPersonDetails?.firstName)
                  : 'New customer'}
              </div>
            </div>
            <div className={styles.userAddressInfo}>
              <ul>
                {(campaign?.incomingCallInfo?.campaignId && currentSession?.isOutboundCampaign) && 
                  <li className={styles.campaignset}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                      <mask id="path-1-inside-1_10261_97119" fill="white">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.2184 8.58751H20.2412C20.5647 8.58751 20.8265 8.31897 20.8259 7.99059C20.8252 7.66179 20.5614 7.3961 20.2383 7.3961H18.2155C17.892 7.3961 17.6302 7.66463 17.6308 7.99297C17.6314 8.32186 17.8953 8.58751 18.2184 8.58751ZM15.8175 3.17513L16.8289 1.39491C16.9905 1.1105 16.896 0.745496 16.6161 0.580479C16.3366 0.415716 15.9769 0.511849 15.8151 0.796597L14.8037 2.57681C14.6421 2.86122 14.7366 3.22623 15.0165 3.39125C15.296 3.55601 15.6557 3.45988 15.8175 3.17513ZM18.1578 5.30754L19.8184 4.33318C20.1003 4.16778 20.1969 3.80154 20.0341 3.51501C19.8714 3.22852 19.511 3.13039 19.229 3.29579L17.5684 4.27019C17.2865 4.43559 17.19 4.80183 17.3527 5.08836C17.5155 5.37481 17.8758 5.47294 18.1578 5.30754Z" />
                      </mask>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M18.2184 8.58751H20.2412C20.5647 8.58751 20.8265 8.31897 20.8259 7.99059C20.8252 7.66179 20.5614 7.3961 20.2383 7.3961H18.2155C17.892 7.3961 17.6302 7.66463 17.6308 7.99297C17.6314 8.32186 17.8953 8.58751 18.2184 8.58751ZM15.8175 3.17513L16.8289 1.39491C16.9905 1.1105 16.896 0.745496 16.6161 0.580479C16.3366 0.415716 15.9769 0.511849 15.8151 0.796597L14.8037 2.57681C14.6421 2.86122 14.7366 3.22623 15.0165 3.39125C15.296 3.55601 15.6557 3.45988 15.8175 3.17513ZM18.1578 5.30754L19.8184 4.33318C20.1003 4.16778 20.1969 3.80154 20.0341 3.51501C19.8714 3.22852 19.511 3.13039 19.229 3.29579L17.5684 4.27019C17.2865 4.43559 17.19 4.80183 17.3527 5.08836C17.5155 5.37481 17.8758 5.47294 18.1578 5.30754Z" fill="#757676" />
                      <path d="M20.8259 7.99059L19.3259 7.99364V7.99365L20.8259 7.99059ZM17.6308 7.99297L19.1308 7.99011L19.1308 7.98992L17.6308 7.99297ZM15.8175 3.17513L17.1217 3.91616L17.1217 3.91609L15.8175 3.17513ZM16.8289 1.39491L15.5247 0.653939L15.5247 0.65395L16.8289 1.39491ZM16.6161 0.580479L17.3779 -0.711676L17.3779 -0.711693L16.6161 0.580479ZM15.8151 0.796597L17.1193 1.53756L17.1194 1.53748L15.8151 0.796597ZM14.8037 2.57681L16.1079 3.31779L16.1079 3.31778L14.8037 2.57681ZM15.0165 3.39125L14.2547 4.6834L14.2547 4.68342L15.0165 3.39125ZM18.1578 5.30754L18.9168 6.60129L18.9168 6.60129L18.1578 5.30754ZM19.8184 4.33318L19.0593 3.03942L19.0593 3.03943L19.8184 4.33318ZM20.0341 3.51501L21.3384 2.77416L21.3383 2.77408L20.0341 3.51501ZM19.229 3.29579L18.47 2.00199L18.4699 2.00207L19.229 3.29579ZM17.5684 4.27019L18.3275 5.56395L18.3275 5.56392L17.5684 4.27019ZM17.3527 5.08836L16.0484 5.82921L16.0485 5.82938L17.3527 5.08836ZM18.2184 8.58751V10.0875H20.2412V8.58751V7.08751H18.2184V8.58751ZM20.2412 8.58751V10.0875C21.4226 10.0875 22.3282 9.11696 22.3259 7.98754L20.8259 7.99059L19.3259 7.99365C19.3249 7.52099 19.7068 7.08751 20.2412 7.08751V8.58751ZM20.8259 7.99059L22.3259 7.98755C22.3236 6.84887 21.4059 5.8961 20.2383 5.8961V7.3961V8.8961C19.7169 8.8961 19.3269 8.47471 19.3259 7.99364L20.8259 7.99059ZM20.2383 7.3961V5.8961H18.2155V7.3961V8.8961H20.2383V7.3961ZM18.2155 7.3961V5.8961C17.0341 5.8961 16.1285 6.86658 16.1308 7.99602L17.6308 7.99297L19.1308 7.98992C19.1318 8.46268 18.7498 8.8961 18.2155 8.8961V7.3961ZM17.6308 7.99297L16.1308 7.99583C16.133 9.13484 17.0509 10.0875 18.2184 10.0875V8.58751V7.08751C18.7397 7.08751 19.1299 7.50888 19.1308 7.99011L17.6308 7.99297ZM15.8175 3.17513L17.1217 3.91609L18.1331 2.13587L16.8289 1.39491L15.5247 0.65395L14.5133 2.43417L15.8175 3.17513ZM16.8289 1.39491L18.1331 2.13588C18.6911 1.1537 18.3775 -0.122355 17.3779 -0.711676L16.6161 0.580479L15.8543 1.87263C15.4145 1.61335 15.2898 1.06731 15.5247 0.653939L16.8289 1.39491ZM16.6161 0.580479L17.3779 -0.711693C16.3716 -1.3049 15.0836 -0.952528 14.5108 0.0557134L15.8151 0.796597L17.1194 1.53748C16.8701 1.97623 16.3016 2.13633 15.8543 1.87265L16.6161 0.580479ZM15.8151 0.796597L14.5109 0.0556346L13.4995 1.83585L14.8037 2.57681L16.1079 3.31778L17.1193 1.53756L15.8151 0.796597ZM14.8037 2.57681L13.4995 1.83584C12.9415 2.81803 13.2551 4.09408 14.2547 4.6834L15.0165 3.39125L15.7783 2.09909C16.2181 2.35838 16.3428 2.90442 16.1079 3.31779L14.8037 2.57681ZM15.0165 3.39125L14.2547 4.68342C15.2611 5.27668 16.5489 4.92414 17.1217 3.91616L15.8175 3.17513L14.5133 2.4341C14.7624 1.99562 15.3309 1.83534 15.7783 2.09908L15.0165 3.39125ZM18.1578 5.30754L18.9168 6.60129L20.5775 5.62693L19.8184 4.33318L19.0593 3.03943L17.3987 4.01379L18.1578 5.30754ZM19.8184 4.33318L20.5775 5.62694C21.5766 5.04074 21.9006 3.76402 21.3384 2.77416L20.0341 3.51501L18.7298 4.25586C18.4931 3.83906 18.624 3.29481 19.0593 3.03942L19.8184 4.33318ZM20.0341 3.51501L21.3383 2.77408C20.768 1.77019 19.4835 1.40749 18.47 2.00199L19.229 3.29579L19.988 4.5896C19.5385 4.8533 18.9747 4.68685 18.7299 4.25594L20.0341 3.51501ZM19.229 3.29579L18.4699 2.00207L16.8093 2.97647L17.5684 4.27019L18.3275 5.56392L19.9882 4.58952L19.229 3.29579ZM17.5684 4.27019L16.8094 2.97644C15.8102 3.56263 15.4862 4.83936 16.0484 5.82921L17.3527 5.08836L18.657 4.34751C18.8937 4.76431 18.7628 5.30856 18.3275 5.56395L17.5684 4.27019ZM17.3527 5.08836L16.0485 5.82938C16.6188 6.8331 17.9034 7.1959 18.9168 6.60129L18.1578 5.30754L17.3987 4.01378C17.8483 3.74997 18.4121 3.91652 18.6569 4.34735L17.3527 5.08836Z" fill="#757676" mask="url(#path-1-inside-1_10261_97119)" />
                      <path d="M9.16577 18.2725L8.74683 18.6582L7.17749 16.5957L7.67554 16.3037L9.16577 18.2725ZM6.35815 14.3574L4.7478 15.3027C3.74701 15.8899 2.44536 15.5419 1.86011 14.5117C1.2713 13.4748 1.62982 12.1384 2.63745 11.5469L4.23022 10.6113L6.35815 14.3574Z" stroke="#757676" stroke-width="1.5" />
                      <path d="M10.9053 1.95532C11.1764 1.79633 11.5362 1.88738 11.7002 2.17603L13.6592 5.62427L14.0889 6.3811L14.7744 5.84302L14.8682 5.77954C15.2591 5.55016 15.7647 5.68079 15.998 6.09106C16.2352 6.50854 16.0897 7.03705 15.6914 7.27075C15.659 7.28981 15.6254 7.30713 15.5908 7.32153L14.8086 7.64771L15.2266 8.38403L17.1855 11.8323C17.3533 12.1277 17.2472 12.5078 16.9688 12.6711C16.716 12.8194 16.3853 12.7504 16.209 12.5061L16.0254 12.2512L15.7158 12.2034L15.2725 12.1448C13.1874 11.914 10.6586 12.249 8.13574 13.1545L6.06055 9.50122C8.24646 7.60878 9.87953 5.38908 10.6768 3.31665L10.7881 3.02563L10.6611 2.74146C10.5324 2.45346 10.6447 2.10821 10.9053 1.95532Z" stroke="#757676" stroke-width="1.5" />
                      <circle cx="14.8259" cy="7" r="1" fill="#757676" />
                    </svg>

                    <div className={styles.campaignmic}>
                      <p>{campaign?.incomingCallInfo?.campaignname && (
                            <>{campaign.incomingCallInfo.campaignname} Campaign</>
                          )}</p>
                      <span>{<> ID :{campaign?.incomingCallInfo?.customerUniqueId ?? "-"}</>}
                      </span>
                    </div>
                  </li>}
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="16" viewBox="0 0 20 16" fill="none">
                    <path d="M19.725 1.76C19.515 1.29 19.185 0.89 18.775 0.59C18.275 0.22 17.665 0 16.995 0H3.005C2.315 0 1.675 0.24 1.175 0.63C0.775005 0.93 0.455005 1.34 0.245005 1.81C0.0950049 2.18 0.00500488 2.58 0.00500488 3V13C0.00500488 14.66 1.345 16 3.005 16H16.995C18.655 16 19.995 14.66 19.995 13V3C19.995 2.56 19.895 2.14 19.725 1.76ZM3.005 1.5H16.995C17.0883 1.5 17.1757 1.5267 17.2654 1.5437L10.465 5.84C10.185 6.0201 9.825 6.0201 9.545 5.85L2.6616 1.5572C2.7745 1.5301 2.8873 1.5 3.005 1.5ZM18.495 13C18.495 13.83 17.825 14.5 16.995 14.5H3.005C2.175 14.5 1.505 13.83 1.505 13V3C1.505 2.8818 1.5259 2.756 1.5569 2.6296L8.7449 7.12C9.1249 7.36 9.5549 7.47 9.9949 7.47C10.4349 7.47 10.8749 7.35 11.2649 7.11L18.4248 2.5822C18.4659 2.7215 18.4949 2.8608 18.4949 3L18.495 13Z" fill="#757676" />
                  </svg>
                  {
                    (currentSession?.calledPersonDetails !== undefined && currentSession?.calledPersonDetails !== null && Object.keys(currentSession?.calledPersonDetails)?.length > 0 && currentSession?.calledPersonDetails !== null && currentSession?.calledPersonDetails?.email !== 'null'
                      && currentSession?.calledPersonDetails?.email !== '' && currentSession?.calledPersonDetails?.email !== 'undefined' && currentSession?.calledPersonDetails.email !== '[]')
                      ?
                      (JSON.parse(currentSession?.calledPersonDetails?.email)?.length === 1 && JSON.parse(currentSession?.calledPersonDetails?.email)[0] === 'undefined')
                        ? "Not available"
                        : JSON.parse(currentSession?.calledPersonDetails?.email)?.length === 1 ?
                          JSON.parse(currentSession?.calledPersonDetails?.email)[0] || "Not available"
                          : <> {JSON.parse(currentSession?.calledPersonDetails?.email)[0]}
                            <Tooltip trigger='hover' placement="bottomRight"
                              title={<div>{JSON.parse(currentSession?.calledPersonDetails?.email)?.slice(1)?.map((d: any) => <div>{d}</div>)}</div>}>
                              <span className={styles.moreNum}>
                                {`+${JSON.parse(currentSession?.calledPersonDetails?.email)?.length - 1}`}
                              </span>
                            </Tooltip>

                          </>

                      : "Not available"
                  }
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="22" viewBox="0 0 16 22" fill="none">
                    <path d="M8.01408 2.44995C11.3541 2.44995 14.0741 5.16995 14.0741 8.50995C14.0741 10.49 11.7541 14.6399 8.00408 19.3799C1.96408 12.5799 1.93408 9.08995 1.94408 8.74995C1.96408 8.64995 1.96408 8.62995 1.96408 8.50995C1.96408 5.16995 4.68408 2.44995 8.02408 2.44995M8.01408 0.949951C3.84408 0.949951 0.454079 4.32995 0.454079 8.50995C0.454079 8.50995 -0.245922 12.44 7.07408 20.6C7.14408 20.68 7.36408 20.92 7.71408 21.01C7.81408 21.04 7.91408 21.0499 8.00408 21.0499C8.23408 21.0499 8.40408 20.9799 8.44408 20.9699C8.71408 20.8599 8.88408 20.67 8.94408 20.6C10.9641 18.07 15.5641 11.95 15.5641 8.50995C15.5641 4.33995 12.1841 0.949951 8.00408 0.949951H8.01408Z" fill="#757676" />
                    <path d="M8.01408 7.48995C8.57408 7.48995 9.03408 7.94995 9.03408 8.50995C9.03408 9.06995 8.57408 9.52995 8.01408 9.52995C7.45408 9.52995 6.99408 9.06995 6.99408 8.50995C6.99408 7.94995 7.45408 7.48995 8.01408 7.48995ZM8.01408 5.98995C6.62408 5.98995 5.49408 7.11995 5.49408 8.50995C5.49408 9.89995 6.62408 11.03 8.01408 11.03C9.40408 11.03 10.5341 9.89995 10.5341 8.50995C10.5341 7.11995 9.40408 5.98995 8.01408 5.98995Z" fill="#757676" />
                  </svg>
                  {currentSession?.calledPersonDetails?.state || currentSession?.calledPersonDetails?.country
                    ? `${currentSession?.calledPersonDetails?.state || ''} ${currentSession?.calledPersonDetails?.country || ''}`
                    : (!currentSession?.Location || `${currentSession?.Location}`?.includes('undefined')) ? "Not available" : currentSession?.Location}

                  {/* <span className="linkText">View Map</span> */}
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" viewBox="0 0 20 18" fill="none">
                    <path d="M4.43527 1.5134C4.81737 1.5134 5.18147 1.6911 5.43237 1.9985L6.66077 3.5105C7.03077 3.9656 7.08346 4.6006 6.78866 5.0962L5.78967 6.7925C5.16667 7.8301 5.70056 9.1138 7.53246 10.9658C9.32726 12.7409 10.2586 12.9463 10.803 12.9463C11.1085 12.9463 11.4057 12.8704 11.6962 12.7068L13.386 11.7007C13.5974 11.5772 13.8394 11.512 14.0858 11.512C14.4105 11.512 14.7287 11.6255 14.9834 11.8328L16.4926 13.0594C16.9972 13.471 17.1257 14.1685 16.7762 14.7056L16.6522 14.9043C16.0237 15.8804 14.9481 16.4866 13.8453 16.4866C13.6692 16.4866 13.492 16.471 13.3227 16.4407C11.1706 16.0498 8.82316 14.6013 6.35077 12.1416C3.88397 9.6621 2.43817 7.3179 2.05377 5.1748C1.82877 3.9175 2.44587 2.5776 3.61777 1.8223L3.79627 1.701C3.98757 1.5784 4.20827 1.5134 4.43527 1.5134ZM4.43527 0.0134997C3.93536 0.0134997 3.43307 0.1519 2.98637 0.4385L2.77717 0.5801C1.18467 1.606 0.233265 3.5156 0.577365 5.439C1.02277 7.9224 2.60857 10.5069 5.28757 13.1995C7.98687 15.8853 10.5647 17.4641 13.0548 17.9165C13.3194 17.9639 13.5836 17.9866 13.8454 17.9866C15.4866 17.9866 17.0289 17.0901 17.9134 15.7166L18.0484 15.5005C18.8043 14.3399 18.5411 12.7944 17.441 11.897L15.9295 10.6687C15.3947 10.2332 14.7411 10.012 14.086 10.012C13.5837 10.012 13.0806 10.1421 12.6296 10.4056L10.929 11.4181C10.8954 11.4369 10.8533 11.4464 10.8031 11.4464C10.4392 11.4464 9.64867 10.9491 8.58737 9.8995C7.39287 8.6917 6.91377 7.8346 7.07577 7.5648L8.08127 5.8575C8.69527 4.825 8.58737 3.5023 7.82477 2.5643L6.59667 1.0528C6.04247 0.3736 5.24177 0.0134997 4.43527 0.0134997Z" fill="#757676" />
                    <path d="M15.0199 0.0214999C14.748 -0.0277001 14.488 0.1531 14.4391 0.425C14.39 0.6966 14.5707 0.9566 14.8426 1.0058C16.7665 1.3419 18.3476 3.1607 18.4817 5.1166C18.4926 5.2681 18.4955 5.4199 18.4896 5.5716C18.4785 5.8476 18.6934 6.0801 18.9695 6.091C19.2454 6.1019 19.478 5.8872 19.489 5.6112C19.4964 5.4207 19.4927 5.231 19.4789 5.0438C19.293 2.6195 17.4347 0.4678 15.0199 0.0214999Z" fill="#757676" />
                    <path d="M14.3129 2.2013C14.041 2.1524 13.781 2.3329 13.7322 2.6048C13.6833 2.8767 13.8639 3.1367 14.1358 3.1856C15.2251 3.3707 16.145 4.4261 16.2175 5.5397L16.222 5.7989C16.2113 6.0748 16.4263 6.3071 16.7024 6.3178C16.9783 6.3285 17.2107 6.1135 17.2214 5.8376C17.226 5.7134 17.2237 5.5895 17.2148 5.467C17.0904 3.8849 15.8933 2.4966 14.3129 2.2013Z" fill="#757676" />
                  </svg>
                  {JSON.parse(currentSession?.calledPersonDetails?.phoneNumber ?? 'null') != null || currentSession?.customerNumber
                    ? JSON.parse(currentSession?.calledPersonDetails?.phoneNumber ?? 'null') != null
                      ? JSON.parse(currentSession?.calledPersonDetails?.phoneNumber)?.length > 0
                         ? JSON.parse(currentSession?.calledPersonDetails?.phoneNumber)?.length === 1
                          ? JSON.parse(currentSession?.calledPersonDetails?.phoneNumber)?.[0] || "Not available"
                          : <> {JSON.parse(currentSession?.calledPersonDetails?.phoneNumber)[0]}
                            <Tooltip trigger='hover' placement="bottomRight"
                              title={<div>{JSON.parse(currentSession?.calledPersonDetails?.phoneNumber)?.slice(1).map((d: any) => <div>{d}</div>)}</div>}>
                              <span className={styles.moreNum}>
                                {`+${JSON.parse(currentSession?.calledPersonDetails?.phoneNumber)?.length - 1}`}
                              </span>
                            </Tooltip>
                          </>
                        : (currentSession?.customerNumber ? currentSession?.customerNumber : 'Not available')
                      : "Not available"
                    : "Not available"}

                </li>
                <li>
                  {["Mobile", "Android", "IOS"].includes(currentSession?.DeviceType)
                    ? <svg xmlns="http://www.w3.org/2000/svg" width="12" height="19" viewBox="0 0 12 19" fill="none">
                      <path d="M9.5 0.8125H2.5C1.3954 0.8125 0.5 1.7079 0.5 2.8125V16.8125C0.5 17.9171 1.3954 18.8125 2.5 18.8125H9.5C10.6046 18.8125 11.5 17.9171 11.5 16.8125V2.8125C11.5 1.7079 10.6046 0.8125 9.5 0.8125ZM4.852 1.7315H7.3813C7.519 1.7315 7.6313 1.8438 7.6313 1.9815C7.6313 2.1192 7.519 2.2315 7.3813 2.2315H4.852C4.7143 2.2315 4.602 2.1192 4.602 1.9815C4.602 1.8438 4.7143 1.7315 4.852 1.7315ZM6 17.9112C5.5624 17.9112 5.2076 17.5564 5.2076 17.1188C5.2076 16.6812 5.5623 16.3264 6 16.3264C6.4377 16.3264 6.7924 16.6811 6.7924 17.1188C6.7924 17.5565 6.4376 17.9112 6 17.9112ZM10.2648 15.0774C10.2648 15.2431 10.1305 15.3774 9.9648 15.3774H2.0352C1.8695 15.3774 1.7352 15.2431 1.7352 15.0774V3.1125C1.7352 2.9468 1.8695 2.8125 2.0352 2.8125H9.9648C10.1304 2.8125 10.2648 2.9468 10.2648 3.1125V15.0774Z" fill="#757676" />
                    </svg>
                    : <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                      <path d="M16.2688 0.5H2.2063C1.41528 0.5 0.800049 1.14453 0.800049 1.90625V10.3438C0.800049 11.1348 1.41528 11.75 2.2063 11.75H16.2688C17.0305 11.75 17.675 11.1348 17.675 10.3438V1.90625C17.675 1.14453 17.0305 0.5 16.2688 0.5ZM16.093 10.3438H2.38208C2.26489 10.3438 2.2063 10.2852 2.2063 10.168V2.08203C2.2063 1.99414 2.26489 1.90625 2.38208 1.90625H16.093C16.1809 1.90625 16.2688 1.99414 16.2688 2.08203V10.168C16.2688 10.2852 16.1809 10.3438 16.093 10.3438ZM14.8625 14.7969C14.8625 14.416 14.5403 14.0938 14.1594 14.0938H11.259L10.7024 12.4824C10.6731 12.3359 10.5266 12.2188 10.3801 12.2188H8.06567C7.91919 12.2188 7.77271 12.3359 7.74341 12.4824L7.18677 14.0938H4.31567C3.90552 14.0938 3.61255 14.416 3.61255 14.7969C3.61255 15.207 3.90552 15.5 4.31567 15.5H14.1594C14.5403 15.5 14.8625 15.207 14.8625 14.7969Z" fill="#757676" />
                    </svg>}
                  <div className={styles.addresssplit}>
                    {currentSession?.DeviceType || "Not available"}
                    <span className={styles.smtxt}>{currentSession?.Browser || "Not available"}</span>
                  </div>
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                    <path d="M19.9975 10.8127C19.9967 5.29129 15.5217 0.815686 10.0001 0.815186C4.47826 0.815686 0.00316348 5.29109 0.00256348 10.8128C0.00306348 16.3342 4.47816 20.8093 10.0001 20.8098C15.5217 20.8093 19.9967 16.3339 19.9975 10.8127C19.9975 10.8129 19.9975 10.8124 19.9975 10.8127ZM18.2815 9.97579H14.4468C14.2474 7.36248 13.3618 4.86109 11.8875 2.71169C13.4268 3.06879 14.8036 3.84549 15.8858 4.92679C17.2083 6.25049 18.0855 8.01019 18.2815 9.97579ZM7.22906 9.97579C7.44946 7.41419 8.41066 4.97659 10.0001 2.95739C11.5895 4.97659 12.5508 7.41419 12.7711 9.97579H7.22906ZM12.771 11.6496C12.5505 14.2109 11.5894 16.6485 10.0001 18.6674C8.41076 16.6485 7.44956 14.2109 7.22906 11.6496H12.771ZM4.11416 4.92679C5.19636 3.84559 6.57306 3.06889 8.11246 2.71169C6.63816 4.86109 5.75266 7.36248 5.55316 9.97579H1.71846C1.91446 8.01029 2.79176 6.25049 4.11416 4.92679ZM1.71846 11.6496H5.55326C5.75276 14.2629 6.63816 16.764 8.11236 18.9132C6.57306 18.5561 5.19626 17.7794 4.11406 16.6981C2.79166 15.3744 1.91446 13.6148 1.71846 11.6496ZM15.8857 16.6981C14.8034 17.7793 13.4268 18.556 11.8874 18.9132C13.3616 16.7641 14.2472 14.263 14.4466 11.6496H18.2813C18.0853 13.6148 17.2081 15.3744 15.8857 16.6981Z" fill="#757676" />
                  </svg>
                  {currentSession?.IPAdress?.substring(0, 20) || "Not available"}
                </li>
              </ul>
              <p onClick={updateProfileFunc}>Update Profile</p>
            </div>
          </>

          <>


            <div className={styles.usertagInfo}>
              <div className={`${styles.tagheader} ${styles.tagheadr}`}>
                <div className={styles.tagtitle}>Tags</div>
                {enableChat ? (
                  <a className={styles.addtag} onClick={() => editTagEnable("save")}>
                    {/* <span className="icon__Plus16" onClick={(e) => editTagEnable("save")}></span> */}
                    Save
                  </a>
                ) : (
                  <a className={styles.addtag} onClick={() => editTagEnable("edit")}>
                    {/* <span className="icon__Plus16" onClick={() => editTagEnable("edit")}></span> */}
                    Edit
                  </a>
                )}
              </div>
              {enableChat && (
                <div className={`${styles.tagselect} ${styles.tagselt}`}>
                  <Select
                    placeholder="Add Tag"
                    className={`${styles.tagselectdropdown} antSelect`}
                    suffixIcon={<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
                      <path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#757676" />
                    </svg>}
                    onChange={(e: any) => dispatch(ChatActions.updateTags(e))}
                  >
                    {Array.isArray(allCustomerTagList) && allCustomerTagList.map((data: any, index: any) => {
                      return (
                        <Select.Option value={data?.customerTagName} key={index}>
                          {data?.customerTagName}
                        </Select.Option>
                      );
                    })}
                  </Select>
                </div>
              )}
              {currentSession?.calledPersonDetails?.tags?.length > 0 && (
                <div className={styles.tagview}>
                  {typeof (currentSession?.calledPersonDetails?.tags) === 'string'
                    ? JSON.parse(currentSession?.calledPersonDetails?.tags ?? '[]')
                      ?.map((data: any, index: any) => (
                        <Tag key={index} className={`${styles.tagbutton}`} closable={enableChat} onClose={() => dispatch(ChatActions.removeTags(data))}>
                          {data}
                        </Tag>))
                    : Array.isArray(currentSession?.calledPersonDetails?.tags)
                      ? currentSession?.calledPersonDetails?.tags
                        ?.map((data: any, index: any) => (
                          <Tag key={index} className={`${styles.tagbutton} ${styles.tagbuttoncallchat}`} closable={enableChat} onClose={() => dispatch(ChatActions.removeTags(data))}>
                            {data}
                          </Tag>))
                      : ''
                  }
                </div>
              )}
            </div>


            <div className={styles.chatscreenblock}>
              <h5>Block request</h5>
              <ul>
                <li>
                  <div className={styles.lefters}>

                    <span className="icon__blocked20"></span>
                    <h5>Block Customer Request</h5>
                    <Tooltip placement="top" title="Block Customer Request" overlayClassName="customtooltipsmall">
                      <span className="icon__Info16"></span>
                    </Tooltip>
                  </div>
                  <h6>
                    {(roleId == ROLES.SUPERVISOR_ROLE_ID || roleId == ROLES.ADMIN_ROLE_ID) ?

                      <Switch
                        checked={currentSession?.calledPersonDetails?.blockCustomer === 1 ? true : false}
                        onClick={() => setCustomerBlockModal(true)}
                        size="small"
                      />
                      : (currentSession?.calledPersonDetails?.blockCustomer === 0) ?
                        <Switch
                          checked={currentSession?.calledPersonDetails?.blockCustomerReq === 1 ? true : false}
                          onClick={() => setCustomerBlockReqModal(true)}
                          disabled={currentSession?.calledPersonDetails?.blockCustomerReq === 1}
                          size="small"
                        />
                        :
                        ""
                    }
                  </h6>
                </li>
                <li className={styles.active}>
                  <div className={styles.lefters}>
                    <span className="icon__distrub20"></span> <h5>Do Not Disturb</h5>
                    <Tooltip placement="top" title="Do Not Disturb" overlayClassName="customtooltipsmall">
                      <span className="icon__Info16"></span>
                    </Tooltip>
                  </div>

                  <h6>
                    {(roleId == ROLES.SUPERVISOR_ROLE_ID || roleId == ROLES.ADMIN_ROLE_ID) ?

                      <Switch
                        checked={currentSession?.calledPersonDetails?.doNotDisturb === 1 ? true : false}
                        onClick={() => setDoNotDisturbModal(true)}
                        size="small"
                      />
                      : (currentSession?.calledPersonDetails?.doNotDisturb === 0) ?
                        <Switch
                          checked={currentSession?.calledPersonDetails?.doNotDisturbReq === 1 ? true : false}
                          onClick={() => setDoNotDisturbReqModal(true)}
                          disabled={currentSession?.calledPersonDetails?.doNotDisturbReq === 1}
                          size="small"
                        />
                        :
                        ""
                    }
                  </h6>
                </li>
              </ul>
            </div>

          </>
        </div>


        <Modal
          title={currentSession?.calledPersonDetails?.doNotDisturb == 1 ? "Remove DND Customer" : "DND Customer"}
          open={doNotDisturbModal}
          className="customModal sizeMD customerbutton"
          centered
          destroyOnClose={true}
          closeIcon={<span className="icon__Close16" onClick={() => setDoNotDisturbModal(false)}></span>}
          footer={[
            <Space style={{ gap: "12px" }}>
              <WtButton name="Cancel" className="buttonCancel sizeMd" onClick={() => setDoNotDisturbModal(false)} />
              <WtButton name={currentSession?.calledPersonDetails?.doNotDisturb == 1 ? "Remove DND" : "Activate DND"}
                className="buttonSave deletebtn sizeMd" htmlType="submit" onClick={doNotDisturbFun} />
            </Space>,
          ]}
        >
          <Form form={form} name="basic" preserve={false} labelCol={{ span: 8 }} wrapperCol={{ span: 24 }} initialValues={{ remember: true }} autoComplete="off">
            {currentSession?.calledPersonDetails?.doNotDisturb === 1 ? "Are you sure you want to Remove DND " : "Are you sure you want to DND"}
            <span className="blockname">
              {" "}
              {currentSession?.calledPersonDetails?.firstName} {currentSession?.calledPersonDetails?.lastName}
            </span>
          </Form>
          {currentSession?.calledPersonDetails?.doNotDisturb !== 1 &&
            <>
              <label>Description <label className="mandaryclr">*</label></label>
              <AntTextAreas
                name="description"
                className="textbox textdisabled"
                placeHolder="Enter description here..."
                maxLength={250}
                value={dndDescriptionValue}
                onChange={(e: any) => setDndDescriptionValue(e.target.value)}
              />
            </>
          }
        </Modal>

        <Modal
          title={currentSession?.calledPersonDetails?.blockCustomer === 1 ? "Un Block Customer" : "Block Customer"}
          open={customerBlockModal}
          className="customModal sizeMD customerbutton"
          centered
          destroyOnClose={true}
          closeIcon={<span className="icon__Close16" onClick={() => setCustomerBlockModal(false)}></span>}
          footer={[
            <Space style={{gap: "12px"}}>
              <WtButton name="Cancel" className="buttonCancel" onClick={() => setCustomerBlockModal(false)} />
              <WtButton name={currentSession?.calledPersonDetails?.blockCustomer === 1 ? "Unblock" : "Yes, Block"} className="buttonSave deletebtn" htmlType="submit" onClick={blockCustomerFun} />
            </Space>,
          ]}
        >
          <Form form={form} name="basic" preserve={false} labelCol={{ span: 8 }} wrapperCol={{ span: 24 }} initialValues={{ remember: true }} autoComplete="off">
            {currentSession?.calledPersonDetails?.blockCustomer === 1 ? "Are you sure you want to unblock" : "Are you sure you want to block"} <span className="blockname">
              {currentSession?.calledPersonDetails?.firstName} {currentSession?.calledPersonDetails?.lastName}
            </span>
          </Form>
          {currentSession?.calledPersonDetails?.blockCustomer !== 1 &&
            <>
              <label>Description <label className="mandaryclr">*</label></label>
              <AntTextAreas
                name="description"
                className="textbox textdisabled"
                placeHolder="Enter description here..."
                maxLength={250}
                value={blockDescriptionValue}
                onChange={(e: any) => setBlockDescriptionValue(e.target.value)}
              />
            </>
          }
        </Modal>
       
        
        <Modal
          title={currentSession?.calledPersonDetails?.blockCustomerReq === 1 ? "Un Block Customer" : "Block Customer"}
          open={customerBlockReqModal}
          className="customModal sizeMD"
          centered
          destroyOnClose={true}
          closeIcon={<span className="icon__Close16" onClick={() => setCustomerBlockReqModal(false)}></span>}
          footer={[
            <Space>
              <WtButton name="Cancel" className="buttonCancel" onClick={() => setCustomerBlockReqModal(false)} />
              <WtButton name={currentSession?.calledPersonDetails?.blockCustomerReq === 1 ? "Unblock" : "Block"} className="buttonSave" htmlType="submit" onClick={blockCustomerFun} />
            </Space>,
          ]}
        >
          <div className="modalcont">
            <Form form={form} name="basic" preserve={false} labelCol={{ span: 8 }} wrapperCol={{ span: 24 }} initialValues={{ remember: true }} autoComplete="off">
              {currentSession?.calledPersonDetails?.blockCustomerReq === 1 ? "Are you sure you want to unblock" : "Are you sure you want to block"}
              <span className="blockname">
                {currentSession?.calledPersonDetails?.firstName} {currentSession?.calledPersonDetails?.lastName}
              </span>
            </Form>
            <label>Description<label className="mandaryclr">*</label></label>
            <AntTextAreas
              name="description"
              className="textbox textdisabled"
              placeHolder="Enter description here..."
              maxLength={250}
              value={blockDescriptionValue}
              onChange={(e: any) => setBlockDescriptionValue(e.target.value)}
            />

          </div>
        </Modal>

        <Modal
          title={currentSession?.calledPersonDetails?.doNotDisturbReq == 1 ? "Remove DND Customer" : "DND Customer"}
          open={doNotDisturbReqModal}
          className="customModal sizeMD"
          centered
          destroyOnClose={true}
          closeIcon={<span className="icon__Close16" onClick={() => setDoNotDisturbReqModal(false)}></span>}
          footer={[
            <Space>
              <WtButton name="Cancel" className="buttonCancel" onClick={() => setDoNotDisturbReqModal(false)} />
              <WtButton name={currentSession?.calledPersonDetails?.doNotDisturbReq == 1 ? "Remove DND" : "DND"} className="buttonSave deletebtn" htmlType="submit" onClick={doNotDisturbFun} />
            </Space>,
          ]}
        >
          <Form form={form} name="basic" preserve={false} labelCol={{ span: 8 }} wrapperCol={{ span: 24 }} initialValues={{ remember: true }} autoComplete="off">
            {currentSession?.calledPersonDetails?.doNotDisturbReq === 1 ? "Are you sure you want to Remove DND " : "Are you sure you want to DND"}
            <span className="blockname">
              {currentSession?.calledPersonDetails?.firstName} {currentSession?.calledPersonDetails?.lastName}
            </span>
          </Form>
          <label>Description <label className="mandaryclr">*</label></label>
          <AntTextAreas
            name="description"
            className="textbox textdisabled"
            placeHolder="Enter description here..."
            maxLength={250}
            value={dndDescriptionValue}
            onChange={(e: any) => setDndDescriptionValue(e.target.value)}
          />
        </Modal>
      </>
      {openUpdateForm.open 
      && <CreateForm 
          open={true} 
          onClose={onCloseContactForm} 
          edit_create={'edit'} 
          customerID={openUpdateForm.coid} 
          enableMerge={true}
          onMerge={onMergeModel}
        />}

      {openMergeForm.open 
      && <MergeContact open={true} id={openMergeForm.coid} onClose={onCloseContactForm} />}

      
    </>
  );
}
export default LeftSidebarProfile;
